<template>
	<div>
		<div class="container img_header" v-if="!isMobile">
			<div :style="cssPropsHeader" class=" "></div>
			<div class="row g-5 box-form ">
				<div class="col-md-12 col-lg-12">
					<h1 class="mb-3" style="color: #f9b6ad">ตรวจสอบสถานะจัดส่ง</h1>
					<div class="row g-3">
						<div class="col-xxl-8 col-md-7 col-sm-12 offset-xxl-1 offset-md-1">
							<div class="input-group mb-3">
								<button style="border-color: #f9b6ad" :class="{ 'border-danger': status.isActive }"
									class="btn  dropdown-toggle" type="button" data-bs-toggle="dropdown"
									aria-expanded="false">{{ type_search }}</button>
								<ul class="dropdown-menu dropdown-menu-end">
									<li><a class="dropdown-item" href="#" @click="SelectType('SO')">SO</a></li>

									<li>
										<hr class="dropdown-divider">
									</li>
									<li><a class="dropdown-item" href="#" @click="SelectType('PO')">PO</a></li>
								</ul>
								<input :maxlength="max_length" minlength="5" @keypress="onlyNumber"
									v-on:keyup.enter="ValidateSONumber" type="text" v-model="soNumber" name="soNumber"
									class="form-control" :placeholder="'กรุณากรอกเลข ' + type_search"
									style="border-color: #f9b6ad" :class="{ 'border-danger': status.isActive }">
							</div>
							<div id="emailHelp" class="form-text text-danger" v-if="status.wrongSO">ไม่พบหมมายเลข
								{{ type_search }}
								กรุณาหรอกใหม่</div>
							<div id="emailHelp" class="form-text text-danger" v-if="status.blankSO">กรุณากรอกเลข
								{{ type_search }}
							</div>
						</div>
						<div class="col-xxl-2 col-md-3 col-sm-12">
							<button class="w-100 btn btn-primary btn btn-custom" type="button"
								@click="ValidateSONumber">ตรวจ {{ type_search }}</button>
						</div>
					</div>
					<div class="row ">
						<div class="col offset-sm-1"></div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>

			<div class=" container col-md-12 col-lg-12">
				<img src="../assets/banner.jpg" alt="" width="384" style=" width:100%; ">
				<h1 class="mb-3 mt-3" style="color: #f9b6ad">ตรวจสอบสถานะจัดส่ง</h1>
				<div class="row g-3">
					<div class="col-xxl-8 col-md-7 col-sm-12 offset-xxl-1 offset-md-1">
						<div class="input-group mb-3">
							<button style="border-color: #f9b6ad" :class="{ 'border-danger': status.isActive }"
								class="btn  dropdown-toggle" type="button" data-bs-toggle="dropdown"
								aria-expanded="false">{{ type_search }}</button>
							<ul class="dropdown-menu dropdown-menu-end">
								<li><a class="dropdown-item" href="#" @click="SelectType('SO')">SO</a></li>

								<li>
									<hr class="dropdown-divider">
								</li>
								<li><a class="dropdown-item" href="#" @click="SelectType('PO')">PO</a></li>
							</ul>
							<input :maxlength="max_length" minlength="5" @keypress="onlyNumber"
								v-on:keyup.enter="ValidateSONumber" type="text" v-model="soNumber" name="soNumber"
								class="form-control" :placeholder="'กรุณากรอกเลข ' + type_search"
								style="border-color: #f9b6ad" :class="{ 'border-danger': status.isActive }">
						</div>
						<div id="emailHelp" class="form-text text-danger" v-if="status.wrongSO">ไม่พบหมมายเลข
							{{ type_search }}
							กรุณาหรอกใหม่</div>
						<div id="emailHelp" class="form-text text-danger" v-if="status.blankSO">กรุณากรอกเลข
							{{ type_search }}
						</div>
					</div>
					<div class="col-xxl-2 col-md-3 col-sm-12">
						<button class="w-100 btn btn-primary btn btn-custom" type="button" @click="ValidateSONumber">ตรวจ {{
							type_search }}</button>
					</div>
				</div>
				<div class="row ">
					<div class="col offset-sm-1"></div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { ref, onMounted, inject, reactive } from 'vue';
import { useRouter } from 'vue-router'
import axios from 'axios';
import { useStore } from 'vuex'

export default {
	setup() {

		localStorage.removeItem('search');
		localStorage.removeItem('data');
		localStorage.removeItem('data_myso');
		localStorage.removeItem('dateStart');
		localStorage.removeItem('dateEnd');
		localStorage.removeItem('searchPoDetail');
		const cryoptojs = inject('cryptojs')
		const CryptoJS = inject('cryptojs')

		const router = useRouter()
		const soNumber = ref('');
		const status = ref('');
		const type_search = ref('SO');
		const max_length = ref('10');
		const store = useStore()
		const onlyNumber = ($event) => {
			if (type_search.value == 'SO') {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
					$event.preventDefault();
				}
			}
		}

		const isMobile = ref("")
		const checkIsMobile = () => {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				isMobile.value = true
			} else {
				isMobile.value = false
			}
		}


		const token = reactive({
			data: ""
		})
		const toaomt_role_user = reactive({
			data: ""
		})
		const toaomt_admin = reactive({
			data: ""
		})

		onMounted(() => {
			toaomt_role_user.data = localStorage.getItem('toaomt_role_user')
			toaomt_admin.data = localStorage.getItem('toaomt_admin')


			if (toaomt_role_user.data) {

				const token_role_user_result = CryptoJS.AES.decrypt(toaomt_role_user.data, process.env.VUE_APP_CRYPTO_SECRETKEY_key).toString(CryptoJS.enc.Utf8);
				if (token_role_user_result == process.env.VUE_APP_IS_SALE) {
					router.push({
						name: "mycustomer",
					})
				}
				if (token_role_user_result == process.env.VUE_APP_IS_STORE) {
					router.push({
						name: "mystore",
					})
				}
			}
			if (toaomt_admin.data) {
				const token_role_admin = CryptoJS.AES.decrypt(toaomt_admin.data, process.env.VUE_APP_CRYPTO_SECRETKEY_key).toString(CryptoJS.enc.Utf8);
				if (token_role_admin == process.env.VUE_APP_IS_ADMIN) {
					router.push({
						name: "admin",
					})
				}
			}

			checkIsMobile();
		})

		const SelectType = (type) => {
			type_search.value = type
			if (type == 'SO') {
				max_length.value = '10';
			} else {
				max_length.value = '32';
			}
		}

		const ValidateSONumber = () => {

			var wrongSO = false;
			var blankSO = false;
			var isActive = false;
			if (soNumber.value === "") {
				blankSO = true;
			} else if (soNumber.value.length < 5) {
				alert("ต้องมากกว่า 5 ตัวอักษร");
				return false
			}
			else {

				if ((soNumber.value.match(/\./g) || []).length == soNumber.value.length) {
					alert("ไม่สามารถค้นหาได้ด้วยตัวอักษรนี้");
					return false;
				}

				if (soNumber.value == "." || soNumber.value == ".." || soNumber.value == "*") {
					alert("ไม่สามารถค้นหาได้")
					return false;
				}

				store.state.raw_SO = soNumber.value;
				if (type_search.value == 'SO') {
					var url = process.env.VUE_APP_API_URL_BACKEND + 'data'

					var data_send = {
						"type": type_search.value,
						"sonumber": soNumber.value,
					}


				} else {
					let soldto = prompt("กรุณากรอกรหัสร้านค้า", "");
					if (soldto == null || soldto == "") {
						alert("กรุณากรอกรหัสร้านค้า");
						return false
					} else {

						store.state.customerId = soldto;
					}

					var url = process.env.VUE_APP_API_URL_BACKEND + 'datapo'
					var data_send = {
						"soldto": store.state.customerId,
						"ponumber": soNumber.value,
					}

				}


				const cryptoInfo = CryptoJS.AES.encrypt(JSON.stringify(data_send), process.env.VUE_APP_CRYPTO_SECRETKEY_key).toString();

				localStorage.setItem('search', cryptoInfo)

				axios.post(url, { higW8Q4KJ2C7rnrA: 'QdQ9rZz5laMV7Fx7' },
					{
						headers: {
							'PXYgHu7VSmIq584q8x2Pkmy7XKo0p63h': cryptoInfo,
						}
					}
				)
					.then(res => {
						localStorage.setItem('data', res.data)
						// localStorage.setItem('data_myso', res.data)
						store.state.search_text = soNumber.value;
						if (type_search.value == 'SO') {
							router.push({
								name: "sopage",
							})
						} else {
							router.push({
								name: "popage_soldto",
							})
						}
					})
					.catch(err => {
						console.log(err);
						if (err.response.status == 400) {
							if (err.response.data.needSoldTo) {
							} else {
								if (err.response.data.message) {
									alert(err.response.data.message)
								} else {
									alert("ไม่พบข้อมูล")
								}
							}
							return false;
						}
					})


				return false
			}
			if (blankSO == false || wrongSO == false) {
				var isActive = true
			}

			status.value = {
				wrongSO: wrongSO,
				blankSO: blankSO,
				isActive: isActive,
			}
		}

		return {
			soNumber,
			ValidateSONumber,
			status,
			onlyNumber,
			SelectType,
			type_search,
			max_length,
			isMobile,
		}
	},
	methods: {
	},
	data() {

		return {
			cssPropsHeader: {
				backgroundImage: `url(${require("@/assets/banner.jpg")})`,
				backgroundRepeat: " no-repeat",
				height: "42.4vh",
				width: "100%",
				margin: "auto",
				display: "block",
				minWidth: "100%",
				backgroundPosition: "center",
				backgroundSize: "cover",
				position: "relative",
			},
			cssPropsFooter: {
				backgroundImage: `url(${require("@/assets/bgg.png")})`,
				height: "15vh",
				backgroundRepeat: " no-repeat",
			}
		};
	}
}
</script>

<style lang="scss" scoped>
.box-form {
	border-radius: 25px;
	background: white;
	position: absolute;
	width: 50%;
	height: 25%;
	top: calc(40vh - (
				/* height */
				100px / 2));
	left: 26.25%;
	box-shadow: #f9b6ad 0px 5px 15px;
}

.btn-custom:hover {
	background: #f9b6ad;
	border-color: #f9b6ad;
}

.btn-custom {
	background: #f9b6ad;
	border-color: #f9b6ad;
}

.btn-custom:link {
	background: #f9b6ad;
	border-color: #f9b6ad;
}

/* visited link */
.btn-custom:visited {
	background: #f9b6ad;
	border-color: #f9b6ad;
}

/* mouse over link */
.btn-custom:hover {
	background: #f9b6ad;
	border-color: #f9b6ad;
}

/* selected link */
.btn-custom:active {
	background: #f9b6ad;
	border-color: #f9b6ad;
}

/* selected link */
.btn-custom:focus {
	background: #f9b6ad;
	border-color: #f9b6ad;
}

// Small devices (landscape phones, 576px and up)
@media (max-width: 390px) {
	.img_header {
		padding-right: 0px !important;
		padding-left: 0px !important;
	}

	.box-form {
		width: 95%;
		height: 30%;
		left: 8.5%;
	}

	.img_footer {
		margin-top: 10px !important;
	}
}

@media (max-width: 767px) {
	.box-form {
		width: 60%;
		height: 30%;
		top: calc(40vh - (
					/* height */
					100px / 2));
		left: 23.25%;
	}
}

@media (max-width: 595px) {
	.box-form {
		width: 70%;
		height: 40%;
		left: 19%;
	}
}

@media (max-width: 487px) {
	.box-form {
		width: 80%;
		height: 30%;
		left: 15%;
	}
}

@media (max-width: 412px) {
	.box-form {
		width: 90%;
		height: 30%;
		left: 11%;
	}
}

@media (max-width: 384px) {
	.box-form {
		width: 90%;
		height: 50%;
		left: 11%;
		// top: 40%;
		// top: calc(40vh - (
		// 			/* height */
		// 			100px / 2));
	}
}

@media (max-width: 357px) {
	.box-form {
		width: 100%;
		height: 30%;
		left: 6.6%;
	}
}

@media (max-height: 129px) {
	.box-form {
		width: 100%;
		height: 100%;
		left: 6.6%;
	}
}
</style>
